
async function refreshCartDrawer2() {
  try {
    // fetch sections + cart in parallel (faster)
    const [sectionsRes, cartRes] = await Promise.all([
      fetch('/?sections=cart-drawer,cart-icon-bubble'),
      fetch('/cart.js')
    ]);

    const data = await sectionsRes.json();
    const cart = await cartRes.json();

    const drawer = document.querySelector('cart-drawer');

    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents({
        sections: data,
        id: 'free-gift-update'
      });

      // ✅ EMPTY STATE TOGGLE
      if (cart.item_count === 0) {
        drawer.classList.add('is-empty');
      } else {
        drawer.classList.remove('is-empty');
      }
    }

  } catch (e) {
    console.error('Drawer refresh error:', e);
  }
}
document.addEventListener('click', async function (e) {
  const btn = e.target.closest('#addBtn:not([disabled])');
  if (!btn) return;

  e.preventDefault();

  // 1. Main variant
  const activeVariant = document.querySelector('.metal-btn.active');
  if (!activeVariant) {
    console.warn('No active variant selected');
    return;
  }

  const variantId = activeVariant.getAttribute('variant_id');

  // 2. Personalization variant (second product)
  const personalizationDropdown = document.querySelector('#personalizationVariant');
  const personalizationVariantId = personalizationDropdown?.value;

  // 3. Collect images
  const images = Array.from(
    document.querySelectorAll('#frontTiles img')
  ).map(img => img.getAttribute('src')).filter(Boolean);

  const images_back = Array.from(
    document.querySelectorAll('#backTiles img')
  ).map(img => img.getAttribute('src')).filter(Boolean);

  // 4. Build properties
  const properties = {};

  const engravingInput = document.querySelector('#engraveInput');
  const engravingText = engravingInput?.value || '';
  const engravingTextTrim = engravingText.trim();
  const engravingFont = document.querySelector('button.font-btn.active span.lbl').textContent;
  const photoNotes = document.querySelector('textarea#photoNotes');
  const Notes = photoNotes?.value || '';
  const NotesTrim = Notes.trim();

  const activeShape = document.querySelector('.shape-btn.active');
  const shape = activeShape?.getAttribute('data-shape');
  const activeChain = document.querySelector('button.chain-btn.active span.name');
  const chain = activeChain?.textContent;
  const activeColour = document.querySelector('.colour-btn.active');
  const Colour = activeColour?.getAttribute('data-colour');

  if (shape) properties['Shape'] = shape;
  if (chain) properties['Chain'] = chain;
  if (chain) properties['Finish'] = Colour;
  if (engravingTextTrim) properties['Engraving Font'] = engravingFont;
  if (engravingTextTrim) properties['Engraving'] = engravingText;
  if (NotesTrim) properties['Anything we should know?'] = Notes;

  images.forEach((img, index) => {
    properties[`Front Photo ${index + 1}`] = img;
  });

  images_back.forEach((img, index) => {
    properties[`Back Photo ${index + 1}`] = img;
  });

  // 5. Build items array
  const items = [
    {
      id: variantId,
      quantity: 1,
      properties: properties
    }
  ];

  // Add second product WITHOUT properties
  if (personalizationVariantId) {
    items.push({
      id: personalizationVariantId,
      quantity: 1
    });
  }

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items })
    });

    const data = await res.json();
    console.log('Added to cart:', data);

    refreshCartDrawer2();
    document.querySelector('a#cart-icon-bubble')?.click();

  } catch (err) {
    console.error('Error adding to cart:', err);
  }
});



